import { TableFeatureFlag } from "../Models/TableFeatureFlag";

function toTableFeatureFlag(data){
    let flags = [];
    for (let flag of data){
        let modFlag = new TableFeatureFlag(flag);
        flags.push(modFlag);
    }
    flags.sort((a,b) => (a.FlagName < b.FlagName) ? -1 : ((a.FlagName > b.FlagName) ? 1 : 0))
    return flags;
}

export {toTableFeatureFlag};